import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/loadingSpinner/Loading";
import AdminDateFilter from "../../components/admin/AdminDateFilter";
import AdminStatCard from "../../components/admin/AdminStatCard";
import { Grid, Paper, Typography } from "@material-ui/core";
import moment from "moment";

@inject("adminStore")
@withRouter
@observer
class AdminOverview extends Component {
    breadcrumb = [{ name: "Admin Dashboard" }];
    
    state = {
        isLoading: true,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { startDate, endDate } = this.state;
        this.setState({ isLoading: true });
        
        this.props.adminStore.getAdminStats(
            startDate.format("YYYY-MM-DD"),
            endDate.format("YYYY-MM-DD")
        ).then(() => {
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    };

    handleDateChange = (startDate, endDate) => {
        this.setState({ startDate, endDate }, this.loadData);
    };

    render() {
        const { isLoading } = this.state;
        const { adminStats } = this.props.adminStore;

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={this.breadcrumb} />
                    <Fragment>
                        <Paper style={{ padding: 16, marginBottom: 16 }}>
                            <Grid container spacing={16} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" style={{ color: "#262626", fontWeight: 600 }}>
                                        Admin Overview
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <AdminDateFilter onDateChange={this.handleDateChange} />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Loading showed={isLoading} />

                    </Fragment>
                </MainContainer>
            </Fragment>
        );
    }
}

export default AdminOverview;
